import slide from './Address'

const selfAddress = {
  install: Vue => {
    Vue.component('myAddress', slide)
  }
}

export default selfAddress



// WEBPACK FOOTER //
// ./src/components/address/index.js